import React, { useState, useEffect } from 'react';
import { Award, Mail, Users } from 'lucide-react';
import { Badge } from '../ui/badge';
import { MemberQuickNav } from '../MemberQuickNav';
import api from '../../lib/api';

export default function OfficerRosterPage() {
  const [officers, setOfficers] = useState(null);
  const backendBase = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    api.get('/officers').then((res) => setOfficers(res.data)).catch(() => setOfficers([]));
  }, []);

  return (
    <main className="min-h-screen bg-[#f1e3eb] pt-44 pb-20 px-4" data-testid="officer-roster-page">
      <div className="max-w-5xl mx-auto">
        <MemberQuickNav />
        <div className="text-center mb-10">
          <span className="text-[#bd8cae] text-sm uppercase tracking-wider font-medium">Members Only</span>
          <h1 className="font-serif text-4xl sm:text-5xl text-[#3c4a2a] mt-2">Officer Roster</h1>
          <p className="text-[#3c4a2a]/70 mt-3 max-w-xl mx-auto">
            The women currently serving as officers of The Women's Club of Lincoln County.
          </p>
        </div>

        {officers === null ? (
          <p className="text-center text-[#3c4a2a]/50">Loading…</p>
        ) : officers.length === 0 ? (
          <div className="text-center bg-white rounded-xl shadow-sm p-10 max-w-lg mx-auto" data-testid="officers-empty">
            <Award className="w-10 h-10 text-[#bd8cae] mx-auto mb-3" />
            <p className="text-[#3c4a2a]/70">
              Officer titles haven't been assigned yet. Once the club elects its officers, they will appear here.
            </p>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {officers.map((o) => (
              <div key={o.id} data-testid={`officer-card-${o.id}`} className="bg-white rounded-xl shadow-md border border-[#bd8cae]/20 p-6 text-center">
                <div className="w-24 h-24 rounded-full overflow-hidden bg-[#bd8cae]/20 mx-auto mb-4 flex items-center justify-center">
                  {o.photo_url ? (
                    <img src={`${backendBase}${o.photo_url}`} alt={o.name} className="w-full h-full object-cover" />
                  ) : (
                    <Users className="w-9 h-9 text-[#a3688f]" />
                  )}
                </div>
                <p className="text-sm uppercase tracking-wider text-[#a3688f] font-semibold" data-testid={`officer-title-${o.id}`}>{o.title}</p>
                <h3 className="font-serif text-xl text-[#3c4a2a] mt-1">{o.name}</h3>
                {o.founding_number ? (
                  <Badge className="bg-[#bd8cae]/25 text-[#a3688f] mt-2">Founding Member #{o.founding_number}</Badge>
                ) : null}
                {o.email && (
                  <p className="mt-3 text-sm">
                    <a href={`mailto:${o.email}`} className="inline-flex items-center gap-1.5 text-[#3c4a2a]/75 hover:text-[#5d6b3c]" data-testid={`officer-email-${o.id}`}>
                      <Mail className="w-3.5 h-3.5 text-[#a3688f]" />
                      {o.email}
                    </a>
                  </p>
                )}
              </div>
            ))}
          </div>
        )}

        <p className="text-center text-sm text-[#3c4a2a]/60 mt-10">
          Officer titles are managed by admins in the Admin Panel, so this page always shows the current officers.
        </p>
      </div>
    </main>
  );
}
